module.exports = __webpack_public_path__ + "static/media/dorm-principal.fad60ce1.jpg";